import { TrustLabelPeriod } from '../../../../../components-library/labels/TrustLabel';

export default {
  labels: {
    [TrustLabelPeriod.LESS_THAN_1_MONTH]: 'Über +100 Kunden haben bereits sicher bei uns bestellt',
    [TrustLabelPeriod.ONE_MONTH_OR_MORE]: 'Über +1.000 Kunden haben bereits sicher bei uns bestellt',
    [TrustLabelPeriod.SIX_MONTHS_OR_MORE]: 'Über +10.000 Kunden haben bereits sicher bei uns bestellt',
  },
  labels_highlight: {
    [TrustLabelPeriod.LESS_THAN_1_MONTH]: 'Über +100 Kunden',
    [TrustLabelPeriod.ONE_MONTH_OR_MORE]: 'Über +1.000 Kunden',
    [TrustLabelPeriod.SIX_MONTHS_OR_MORE]: 'Über +10.000 Kunden',
  },
};
